import request from '@/utils/request'

export function getDicts() {
  return request({
    url: 'admin-auth/api/dict/all',
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'admin-auth/api/dict',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: 'admin-auth/api/dict/' + id,
    method: 'delete'
  })
}

export function edit(data) {
  return request({
    url: 'admin-auth/api/dict',
    method: 'put',
    data
  })
}

export default { add, edit, del }
